function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = {
  userId: null,
  notification: {
    text: '',
    type: '',
    duration: 0,
    hidden: true
  },
  language: 'en',
  dictionaries: {},
  translationMissing: {
    value: false,
    wasShown: false
  },
  signature: {
    defaultRecipientLanguage: null,
    defaultSignatureMethods: null
  }
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'SET_NOTIFICATION':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          notification: _objectSpread(_objectSpread({}, action.notification), {}, {
            hidden: state.notification.text == action.notification.text
          })
        });
      }

    case 'SET_USER_ID':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          userId: action.userId
        });
      }

    case 'SET_LANGUAGE':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          language: action.language
        });
      }

    case 'SET_DICTIONARY':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          dictionaries: _objectSpread(_objectSpread({}, state.dictionaries), {}, _defineProperty({}, action.value.language, action.value.data))
        });
      }

    case 'SET_SIGNATURE_SETTINGS':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          signature: _objectSpread({}, action.value)
        });
      }

    case 'UPDATE_TRANSLATION_MISSING':
      return _objectSpread(_objectSpread({}, state), {}, {
        translationMissing: _objectSpread(_objectSpread({}, state.translationMissing), action.translationMissing)
      });

    default:
      return state;
  }
});